import { Fragment } from "react";
//* import global component

import FormControl from "../UI/FormControl";
//* import styles
import styles from "./SignUpForm.module.css";
//TODO this contains just two form controls
const SignUpForm3 = (props) => {
  const { formState, onDispatchForm } = props;

  const {
    passwordIsValid,
    confirmPasswordIsValid,
    error,
  } = formState;
  const changePasswordHandler = (event) => {
    const value = event.target.value;
    onDispatchForm({
      type: "PASSWORD_INPUT",
      value,
    });
  };
  const changeConfirmPasswordHandler = (
    event
  ) => {
    const value = event.target.value;
    onDispatchForm({
      type: "CONFIRM-PASSWORD_INPUT",
      value,
    });
  };
  return (
    <Fragment>
      <div className={styles["form-controls"]}>
        <FormControl
          error={error.passwordError}
          errorClassName={styles["error"]}
          Input={{
            type: "password",
            id: "password",
            value: formState.passwordValue,
            onChange: changePasswordHandler,
            // onBlur: blurInputHandler,
          }}
          Label={{
            child: {
              label: "Password",
            },
            properties: {
              htmlFor: "password",
            },
          }}
          className={`${styles["form-control"]}
            ${
              passwordIsValid
                ? ""
                : styles["invalid"]
            }`}
        />
      </div>
      <div className={styles["form-controls"]}>
        <FormControl
          error={error.confirmPasswordError}
          errorClassName={styles["error"]}
          Input={{
            type: "password",
            id: "confirm-password",
            value: formState.confirmPasswordValue,
            onChange:
              changeConfirmPasswordHandler,
            // onBlur: blurInputHandler,
          }}
          Label={{
            child: {
              label: "Confirm Password",
            },
            properties: {
              htmlFor: "confirm-password",
            },
          }}
          className={`${styles["form-control"]}
            ${
              confirmPasswordIsValid
                ? ""
                : styles["invalid"]
            }`}
        />
      </div>
    </Fragment>
  );
};

export default SignUpForm3;
